<template>
    <div class="mt-2 mb-2 ml-3">
        <div v-if="match" class="mt-2">
            <div
                class="title mt-2 mb-4 pb-2 layout row"
                style="text-decoration: underline;"
            >
                Match Details
            </div>

            <div class="layout row mb-2">
                <div class="font-weight-medium mr-1 width-200">
                    Registered On:
                </div>
                <div>{{ row.datE_REG | time }}</div>
            </div>
            <div class="layout row mb-2" v-if="row.dob">
                <div class="font-weight-medium mr-1 width-200">
                    Date Of Birth:
                </div>
                <div>{{ row.dob | time }}</div>
            </div>

            <div class="layout row mb-2" v-for="prop in getRowProperties()">
                <div class="font-weight-medium mr-1 width-200">
                    {{ prop.name }}:
                </div>
                <div>{{ prop.value }}</div>
            </div>
        </div>
        <div class="title mt-0" v-else>
            No Match
        </div>
    </div>
</template>
<script>
import moment from "moment";
import { toTitleCase, except, sum } from "../../utils/helpers.js";

export default {
    props: {
        row: Object,
        columns: Array,
        reloadGrid: Function,
    },
    data() {
        return {
            match: "",
        };
    },
    async created() {
        this.loadMatch();
    },
    computed: {},
    methods: {
        async loadMatch() {
            if (!this.row.matchID) return;

            const response = await this.$http.get(
                "api/voting/getMatch?id=" + this.row.matchID
            );

            this.match = response;
        },
        getRowProperties() {
            return Object.keys(
                except(
                    this.match,
                    "vgt_id",
                    "originalIndex",
                    "vgtExpended",
                    "datE_REG",
                    "dob"
                )
            )
                .map((key) => {
                    const column = this.columns
                        .filter((c) => !c.isIcon)
                        .find((c) => c.field == key);

                    return {
                        name: column ? column.label : toTitleCase(key),
                        value: this.row[key],
                    };
                })
                .filter((p) => p.value);
        },
        formatTime(date) {
            return moment(date).format("MM/DD/YYYY h:mm:ss A");
        },
    },
};
</script>
<style></style>
